import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ScrollContainerService } from '../service/scroll-container.service';

@Directive({
  selector: '[appScrollContainer]',
  standalone: true
})
export class ScrollContainerDirective implements OnInit, OnDestroy {
  @Input('appScrollContainer') context: string | undefined;

  constructor(private elRef: ElementRef<HTMLElement>, private registry: ScrollContainerService) {}

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      this.registry.register(this.elRef.nativeElement, this.context);
    }
  }

  ngOnDestroy(): void {
    if (typeof window !== 'undefined') {
      this.registry.unregister(this.elRef.nativeElement, this.context);
    }
  }
}
